"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStateColor = void 0;
var getStateColor = function (state, theme) {
    switch (state) {
        case 'success':
            return theme.BG_GREEN;
        case 'warning':
            return theme.TYPE_ORANGE;
        case 'error':
            return theme.TYPE_RED;
        default:
            return theme.TYPE_DARK_GREY;
    }
};
exports.getStateColor = getStateColor;
